import { render, staticRenderFns } from "./bscCustagent.vue?vue&type=template&id=a8e01de4"
import script from "./bscCustagent.vue?vue&type=script&lang=js"
export * from "./bscCustagent.vue?vue&type=script&lang=js"
import style0 from "./bscCustagent.vue?vue&type=style&index=0&id=a8e01de4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports